module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-layout', [_c('div', {
    staticClass: "backgroundtexture"
  }), _c('div', {
    staticClass: "backgroundimg"
  }), _c('div', {
    staticClass: "backgroundimgborder"
  }), _c('div', {
    staticClass: "behind"
  }, [_c('div', {
    staticClass: "contentsection"
  }, _vm._l((_vm.page.page_containers), function(p) {
    return _c('div', {
      staticClass: "menucontent fl flex"
    }, [_c('div', {
      staticClass: "menustyle"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'info-behind-show',
          params: {
            id: p.container.id
          }
        }
      }
    }, [_vm._v(_vm._s(p.container.titre))])], 1)])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a8791bc","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Film/Behind.vue
// module id = 1276
// module chunks = 1